export default {
  disclaimer: {
    summary:
      'Pamiętaj, że Twoim obowiązkiem jest potwierdzenie poprawności wszystkich walut i podatków dla właściwej jurysdykcji.',
    extra:
      'Informacje te udostępniamy wyłącznie dla wygody i nie ponosimy odpowiedzialności za dokładność walut i/lub podatków ani za ich zapłatę w ramach naszych produktów. Informacje dotyczące walut i podatków mają charakter wyłącznie informacyjny.',
    show_more: 'Pokaż więcej',
    show_less: 'Pokaż mniej',
  },
  partner_note:
    'To są domyślne ustawienia na poziomie partnera. Restauracje powiązane z Twoim kontem dziedziczą te wartości automatycznie, chyba że nadpiszą kategorię indywidualnie.',
  section_title: 'Stawki podatkowe dla pozycji menu',
  new_category_placeholder: 'Nowa kategoria',
  form: {
    name: {
      label: 'Kategoria podatkowa',
    },
    default_tax_rate: {
      label: 'Stawka domyślna',
      tooltip: 'Używana jako wartość zastępcza, gdy konkretna stawka dla metody zamówienia jest pusta.',
    },
    pickup_tax_rate: {
      label: 'Odbiór osobisty',
    },
    delivery_tax_rate: {
      label: 'Dostawa',
    },
    dine_in_tax_rate: {
      label: 'W restauracji',
    },
    on_site_tax_rate: {
      label: 'Zamawianie przy stoliku',
    },
    show_zero_tax_in_summary: {
      label: 'Pokaż 0% podatku w podsumowaniu zamówienia',
    },
  },
  buttons: {
    add_category: 'Dodaj nową kategorię podatkową',
    cancel: 'Anuluj',
    save: 'Zapisz',
    confirm: 'Usuń',
    delete: 'Usuń kategorię',
    reset: 'Przywróć do dziedziczonej',
  },
  delete_confirm: {
    title: 'Usunąć tę kategorię podatkową?',
    description: 'Tej operacji nie można cofnąć.',
  },
  scope_labels: {
    region: 'Cały region',
    partner: 'Cały partner',
    restaurant: 'Cała restauracja',
  },
  confirm_modal: {
    title: {
      fork: 'Uczynić to własną kategorią tej restauracji?',
      owned: 'Zastosować nowe stawki?',
      reset: 'Wrócić do odziedziczonej kategorii?',
    },
    affected_one: '{{count}} produkt lub kategoria jest obecnie powiązana i zostanie obciążona nowymi stawkami.',
    affected_few: '{{count}} produkty i kategorie są obecnie powiązane i zostaną rozliczone według nowych stawek.',
    affected_many:
      '{{count}} produktów i kategorii jest obecnie powiązanych i zostanie rozliczonych według nowych stawek.',
    affected_other: '{{count}} produkty i kategorie są obecnie powiązane i zostaną obciążone nowymi stawkami.',
    affected_settings_one:
      '{{count}} produkt lub kategoria jest obecnie powiązany(a) i będzie używać zaktualizowanych ustawień.',
    affected_settings_few:
      '{{count}} produkty i kategorie są obecnie powiązane i będą używać zaktualizowanych ustawień.',
    affected_settings_many:
      '{{count}} produktów i kategorii jest obecnie powiązanych i będzie używać zaktualizowanych ustawień.',
    affected_settings_other:
      '{{count}} produktów i kategorii jest obecnie powiązanych i będzie używać zaktualizowanych ustawień.',
    restaurants_one: 'To {{count}} restauracja.',
    restaurants_few: 'To {{count}} restauracje.',
    restaurants_many: 'To {{count}} restauracji.',
    restaurants_other: 'To {{count}} restauracji.',
    acknowledge:
      'Rozumiem, że potwierdzenie tego zmieni kategorię podatkową dla wszystkich produktów, które są obecnie powiązane z tą kategorią',
    impact_error: 'Nie udało się sprawdzić, które produkty zostaną zmienione',
    cancel: 'Anuluj',
    confirm: 'Potwierdź',
  },
  toasts: {
    load_error: 'Nie udało się wczytać kategorii podatkowych.',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
    delete_error: 'Nie udało się usunąć tej kategorii podatkowej.',
    category_deleted: 'Kategoria podatkowa usunięta',
    category_reset: 'Kategoria podatkowa przywrócona do odziedziczonej',
    reset_error: 'Nie udało się zresetować tej kategorii podatkowej.',
    impact_error: 'Nie udało się sprawdzić, które produkty zostaną zmienione',
    impact_changed_one: 'Liczba dotkniętych produktów zmieniła się na {{count}}. Sprawdź i potwierdź ponownie.',
    impact_changed_few: 'Liczba objętych produktów zmieniła się na {{count}}. Sprawdź i potwierdź ponownie.',
    impact_changed_many: 'Liczba objętych produktów zmieniła się na {{count}}. Sprawdź i potwierdź ponownie.',
    impact_changed_other: 'Liczba dotkniętych produktów zmieniła się na {{count}}. Sprawdź i potwierdź ponownie.',
  },
};
